import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
   * {
      box-sizing: border-box;
      margin: 0;

      font-family: 'Nunito Sans', sans-serif;
   }

   .material-symbols-outlined {
      font-variation-settings:
      'FILL' 0,
      'wght' 400,
      'GRAD' 0,
      'opsz' 48
   }
`;

export { GlobalStyle };